module.exports = __webpack_public_path__ + "static/media/img_tsukutter_tape.4c111afa.svg";